import { IManagableObject } from "../../IManagableObject";
import { IconViewModel } from "../../../../models/IconViewModel";

/*export class DriversViewModel implements IManagableObject {
  Id: number = 0;
  Name: string;
  Phone: string = "";
  Category: string = "";
  Rank: string = "";
  License: string = "";

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.Phone = data["phone"];
      this.Category = data["category"];
      this.Rank = data["rank"];
      this.License = data["license"];
    }
  }

  static fromJS(data: any): DriversViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new DriversViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}*/

// export class IconViewModel {
//   Id: number;
//   Url: string;
//   UrlCross: string;
//   UrlDisabled: string;
//   Width: number;
//   Height: number;
//   Name: string;

//   init(data?: any) {
//     if (data) {
//       this.Id = data["id"];
//       this.Name = data["name"];
//       this.Url = data["url"];
//       this.UrlCross = data["urlInactive"];
//       this.UrlDisabled = data["urlDisabled"];
//       this.Width = data["width"];
//       this.Height = data["height"];
//     }
//   }

//   static fromJS(data: any): IconViewModel {
//     data = typeof data === 'object' ? data : {};
//     let result = new IconViewModel();
//     result.init(data);
//     return result;
//   }
// }

export class KeySyncViewModel implements IManagableObject {
  ObjectId: number;
  ObjectName: string;
  KeyId: number;
  KeyName: string;
  Name: string = "";
  NeedAdd: boolean;
  NeedDelete: boolean;
  NeedUpdate: boolean;

  isSynced(): boolean {
    return !this.NeedAdd && !this.NeedDelete && !this.NeedUpdate;
  }

  isDeleteRequired(): boolean {
    return this.NeedDelete;
  }

  init(isKey: boolean, data?: any) {
    if (data) {
      this.ObjectId = data["objectId"];
      this.KeyId = data["keyId"];
      this.KeyName = data["keyName"];
      this.ObjectName = data["objectName"];

      this.Id = this.KeyId;
      this.Name = isKey ? this.KeyName : this.ObjectName;

      this.NeedAdd = data["needAdd"];
      this.NeedDelete = data["needDelete"];
      this.NeedUpdate = data["needUpdate"];

    }
  }

  static fromJS(data: any, isKey: boolean): KeySyncViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new KeySyncViewModel();
    result.init(isKey, data);
    return result;
  }

  Id: number;
  IsChecked: boolean;
}

export class KeySyncModel {
  KeyId: number;
  ObjectId: number;
}


export class NewKeyViewModel {
  id: number;
  companyId?: string;
  name: string;
  comment: string;
  type: string;
  driverId?: number;
  driverName: string;
  groupIds: number[];
  uid: number;

  constructor(keyViewModel: KeyViewModel) {
    this.id = keyViewModel.Id;
    this.companyId = keyViewModel.UID == '' ? undefined : keyViewModel.UID;
    this.name = keyViewModel.Name;
    this.comment = keyViewModel.Comment;
    this.type = keyViewModel.Type;
    this.driverId = keyViewModel.DriverId || undefined; // Преобразуем 0 в undefined
    this.driverName = keyViewModel.DriverName;
    this.groupIds = keyViewModel.Groups;
    this.uid = parseInt(keyViewModel.UID, 16);
  }

}
export class KeyViewModel implements IManagableObject {
  Id: number = 0;
  Name: string = "";
  UID: string = "";
  Type: string = "iButton";
  DriverId: number | null = null;
  DriverName: string = "";
  Comment: string = "";
  Groups: number[] = [];
  IsChecked: boolean = false;

  constructor(data?: any) {
    if (data) {
      this.init(data);
    }
  }

  init(data: any): void {
    this.Id = data.id || 0;
    this.Name = data.name || "";
    this.UID = data.uId?.toString(16)?.toUpperCase() || "";
    this.Type = data.type;
    this.DriverId = data.driverId ?? 0;
    this.DriverName = data.driverName || "";
    this.Comment = data.comment || "";
    this.Groups = data.groupIds || [];
    this.IsChecked =  false;
  }

  static fromJS(data: any): KeyViewModel {
    return new KeyViewModel(data);
  }
}

